Array.range = function (n) {
  // Array.range(5) --> [0,1,2,3,4]
  return Array.apply(null, Array(n)).map((x, i) => i);
};

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'chunk', {
  value: function (n) {
    return Array.range(Math.ceil(this.length / n)).map((x, i) =>
      this.slice(i * n, i * n + n)
    );
  },
});

function deepMap(obj, f, ctx) {
  if (obj != null && Array.isArray(obj)) {
    return obj.map((val, key) =>
      val != null && typeof val === 'object'
        ? deepMap(val, f, ctx)
        : f.call(ctx, val, key)
    );
  }
  if (obj != null && typeof obj === 'object') {
    const res = {};
    for (const key in obj) {
      const val = obj[key];
      if (val != null && typeof val === 'object') {
        res[key] = deepMap(val, f, ctx);
      } else {
        res[key] = f.call(ctx, val, key);
      }
    }
    return res;
  }
  return obj;
}

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const getTokenForUser = (user) => {    
  // include the user role for public experience. 
  if (user !== undefined && user !== null && user.profile.role.findIndex((r) => r === 'ECRI Employee' || r === 'ECRI Contractor') !== -1) 
  { 
      return user.access_token;                        
  }
  
  return null;
};

export { deepMap, scrollToTop, getTokenForUser };
